var map = {
	"./charlie_skin213.png": 682,
	"./charlie_skin214.png": 8069,
	"./coockiebaker_skin204.png": 9125,
	"./norman_skin201.png": 5417,
	"./norman_skin202.png": 1995,
	"./skin018 1.png": 3358,
	"./skin021 1.png": 1914,
	"./skin029 1.png": 4189,
	"./skin037 1.png": 8451,
	"./skin039 1.png": 1670,
	"./skin049 1.png": 3605,
	"./skin062 1.png": 1712,
	"./skin086.png": 3693,
	"./skin088.png": 8721,
	"./skin092.png": 3901,
	"./winniefirst_skin207.png": 2730,
	"./winniefirst_skin208.png": 9029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9185;